<template>
  <div class="TopicsCategories">
    <TopicsCategoriesButton
      :category="'dev'"
      title="Web &amp; Mobile dev"
      mobileTitle="Fullstack"
    />
    <div class="divider"></div>
    <TopicsCategoriesButton
      :category="'data'"
      title="Coding &amp; Data structures"
      mobileTitle="Coding"
    />
    <div class="divider"></div>
    <TopicsCategoriesButton
      :category="'design'"
      title="Design patterns &amp; Architecture"
      mobileTitle="Design patterns"
    />
  </div>
</template>

<script>
import TopicsCategoriesButton from './TopicsCategoriesButton';

export default {
  name: 'TopicsCategories',
  components: {
    TopicsCategoriesButton,
  },
};
</script>

<style lang="scss" scoped>
.TopicsCategories {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-bottom: 20px;
}
.divider {
  height: 20px;
  border-right: 1px solid $color-grey;
}

@media screen and (max-width: 650px) {
  .TopicsCategories {
    margin: 20px auto;
  }
}
</style>
